module.exports = __webpack_public_path__ + "static/media/bar-brewery-winery-1.0d17cdf4.jpg";